export function ImgArchive({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-50 -50 450 450"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0,-652.36216)">
        <path d="m 200.25388,652.36195 -200.126955,53.25896 -0.0957,-0.0273 0,0.0527 -0.0312,0.008 0.0312,0.01 0,287.79337 199.984375,58.90472 199.98437,-58.90472 0,-287.8637 -0.20116,0.0586 -199.54493,-53.29023 z m -176.714845,84.96469 164.554685,48.46892 0,238.24614 -164.554685,-48.46892 0,-238.24615 z m 352.953125,0 0,238.24614 -164.55469,48.46892 0,-238.24615 164.55469,-48.46892 z m -335.380855,39.69759 0,47.99226 124.248045,38.00779 0,-47.99226 -124.248045,-38.00779 z" />
      </g>
    </svg>
  );
}